/**
 * Show/hide state for a block's drag handle (hover-driven).
 */

import { useState, useRef, useEffect } from 'react';

export const useHandleVisibility = ({ onChildHoverChange } = {}) => {
  const [showHandle, setShowHandle] = useState(false);
  const [childIsHovered, setChildIsHovered] = useState(false);
  const handleHideTimer = useRef(null);

  const handleMouseEnter = (e) => {
    // A highlight drag crosses every block under the cursor. Showing the
    // handle on each one re-renders the tree for the whole gesture.
    if (e?.buttons === 1) return;
    if (handleHideTimer.current) {
      clearTimeout(handleHideTimer.current);
      handleHideTimer.current = null;
    }
    setShowHandle(true);
    onChildHoverChange?.(true);
  };

  const handleMouseLeave = (e) => {
    if (e?.buttons === 1) return;
    setChildIsHovered(false);
    setShowHandle(false);
    onChildHoverChange?.(false);
  };

  const handleChildHover = (isHovering) => {
    setChildIsHovered(isHovering);
  };

  const showHandleForDragZone = (e) => {
    if (e?.buttons === 1) return;
    if (handleHideTimer.current) {
      clearTimeout(handleHideTimer.current);
      handleHideTimer.current = null;
    }
    setShowHandle(true);
  };

  useEffect(
    () => () => {
      if (handleHideTimer.current) clearTimeout(handleHideTimer.current);
    },
    []
  );

  return {
    showHandle,
    childIsHovered,
    handleMouseEnter,
    handleMouseLeave,
    handleChildHover,
    showHandleForDragZone,
  };
};
